import { useEffect } from 'react';

const useUpdateTitle = (businessName?: string) => {
  useEffect(() => {
    const baseTitle = 'Avantti';

    if (businessName) {
      document.title = `${businessName} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }

    // This is an optional cleanup function. When the component unmounts,
    // it will reset the title back to the base title.
    return () => {
      document.title = baseTitle;
    };
  }, [businessName]); // The effect re-runs only when businessName changes
};

export default useUpdateTitle;
